<template>
  <div class="member-wrapper is-clearfix">
    <div class="header">
      <div class="logo">
        <router-link to="/"></router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'MemberLayout'
}
</script>

<style>
.member-wrapper {
  padding-bottom: 40px;
}
.member-wrapper .header {
  max-width: 1200px;
  margin: 40px auto 60px;
}
.member-wrapper .logo {
  width: 132px;
  height: 76px;
  background: url('../../../assets/img/icon/logo.png') no-repeat;
  background-size: 100% 100%;
}
.member-wrapper .logo a {
  display: block;
  height: 100%;
}
.member-main {
  width: 400px;
  margin: 0 auto;
}
.member-main .title {
  display: flex;
  margin-bottom: 46px;
}
.member-main .title li {
  flex: 1;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  line-height: 28px;
  color: #bdbcbd;
}
.member-main .title li.active {
  color: #1e1e1e;
}
.member-main .el-form-item {
  margin-bottom: 20px;
}
.member-main .el-input__inner {
  height: 50px;
}
.member-main .phone-areacode {
  float: left;
  width: 92px;
}
.member-main .phone-input {
  float: right;
  width: 294px;
}
.member-main .image-code-input {
  float: left;
  width: 260px;
}
.member-main .image-code {
  cursor: pointer;
  float: right;
  width: 126px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: #efefef;
}
.member-main .phone-code-input {
  float: left;
  width: 260px;
}
.member-main .phone-code-btn {
  float: right;
  width: 126px;
  height: 50px;
}
.member-main .btn-block {
  margin-top: 20px;
  width: 100%;
  height: 50px;
}
.member-main .member-bar,
.member-main .member-bar .el-checkbox,
.member-main .member-bar .el-checkbox.is-checked .el-checkbox__label {
  color: #afafaf;
}
.member-main .member-bar .el-checkbox__input {
  margin-top: -1px;
}
.member-main .member-bar a {
  color: #1641fd;
}
.member-main .el-input__icon {
  cursor: pointer;
}
.member-main .el-button--primary {
  background-color: #1e88f5;
  box-shadow: 0 0 10px rgba(30, 136, 245, 0.4);
}
.member-main .el-form-item.is-success .el-input__inner {
  border-color: #d8dce5;
}
</style>
